module.exports = __webpack_public_path__ + "img/defaultXuanzhou.1630993415105.jpg";